import React from 'react';
import Footer from './Footer';

const JoinUs = (props) => {
    console.log(props)
    return props.galleryCategories === undefined ? <></> : (
        <>
          <div className="joinUsPage text-center">
                <h6>JOIN US</h6>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <img src={process.env.REACT_APP_IMAGE_STORAGE + props.galleryCategories[3].galleries[0].image} width="100%" alt=""/>
                        </div>
                        <div className="col-12">
                            <p className="joinUsText">{props.galleryCategories[3].galleries[0].gallery_content}</p>
                        </div>
                    </div>
                </div>
            </div>  
            <div className="footer d-lg-none">

            <Footer />
            </div>
        </>
    );
};

export default JoinUs;